import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@26.1.0_@vue+compiler-sfc@3.5.39_cac@6.7.1_eb72500a1f41e0e5f9efbcd502901003/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}